export const renderIconTextEventHeader = (icon: React.ReactNode, text?: string) =>
  !!text && (
    <p className='text-primary inline-flex items-center gap-0.5'>
      <span className='w-5 h-5 flex items-center justify-center shrink-0'>{icon}</span>
      <span className='text-subtitle-s line-clamp-1'>{text}</span>
    </p>
  );
